import { ReactNode } from 'react';
import { Card } from './Card';
import { useBreakpoints } from '../theme/useBreakpoints';
import { IBreakpoint } from '../theme/utils';

export const WrapWithCardOnLargerScreen: React.FC<{marginTop?: number, marginBottom?: number, breakpoint?: IBreakpoint, children: ReactNode}> = ({ marginTop, marginBottom, breakpoint, children }) => {
    const { isAboveBreakpoint } = useBreakpoints();
    if (isAboveBreakpoint(breakpoint || 'md')) {
        return (
            <div style={{marginTop, marginBottom}}>
                <Card>{children}</Card>
            </div>
        );
    } else {
        return (
            <div>{children}</div>
        );
    }
};
